// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".move-field-modal {\n  max-width: 590px !important;\n}\n.move-field-modal .field-name {\n    font-weight: 400;\n}\n", ""]);
// Exports
module.exports = exports;
